import { useState, useEffect } from "react";
import styles from "@/components/CookieConsentRibbon.module.css";

const CookieConsentRibbon = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("cookieConsent")) {
      setShow(true);
    }
  }, []);

  const handleClose = () => {
    setShow(false);
    localStorage.setItem("cookieConsent", "accepted");
  };

  return (
    <>
      {show && (
        <div className={styles.ribbon}>
          <p>
            By using this website, you agree to our use of cookies. We use
            cookies to provide you with a great experience and to help our
            website run effectively.
          </p>
          <button className={styles.closeButton} onClick={handleClose}>
            &times;
          </button>
        </div>
      )}
    </>
  );
};

export default CookieConsentRibbon;
